// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"471":"activity","535":"login"}[chunkId] + "." + {"471":"8e2e2a4e","535":"61a19cc2"}[chunkId] + ".css";
};